import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "variant", "color", "loading", "asLink"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import Link from '../Link';
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    variant = _ref.variant,
    color = _ref.color,
    loading = _ref.loading,
    asLink = _ref.asLink,
    props = _objectWithoutProperties(_ref, _excluded);
  if (asLink) {
    return /*#__PURE__*/React.createElement(MuiButton, _objectSpread({
      ref: ref,
      variant: variant === 'text' ? undefined : variant,
      color: color,
      component: Link,
      naked: true
    }, props), children);
  }
  return /*#__PURE__*/React.createElement(MuiButton, _objectSpread({
    ref: ref,
    variant: variant === 'text' ? undefined : variant,
    color: color,
    disabled: loading,
    startIcon: loading && /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    })
  }, props), children);
});
Button.displayName = 'Button';
Button.defaultProps = {
  variant: 'contained',
  loading: false,
  asLink: false,
  color: undefined,
  children: ''
};
export default Button;